import { useAtomValue } from "jotai";
import type { SetStateAction } from "react";
import { useCallback, useEffect, useRef, useState } from "react";

import { notEmpty } from "shared/lib/utils";

import { appAtom } from "scmp-app/lib/app/atoms";

export const useDefaultSearchInputSate = ((initValue?: (() => string) | string) => {
  const { defaultSearchString, defaultSearchStringLoaded } = useAtomValue(appAtom);

  const isDirtyReference = useRef(false);
  const [value, setValue] = useState(initValue ?? "");

  useEffect(() => {
    if (
      isDirtyReference.current ||
      defaultSearchStringLoaded !== true ||
      !notEmpty(defaultSearchString) ||
      notEmpty(value)
    ) {
      return;
    }
    setValue(defaultSearchString);
  }, [defaultSearchString, defaultSearchStringLoaded, value]);

  const changeValue = useCallback((next: SetStateAction<string>) => {
    isDirtyReference.current = true;
    setValue(next);
  }, []);

  return [value, changeValue];
}) as typeof useState<string>;
